import styled from 'styled-components';
import Box from '@material-ui/core/Box';
import MUIDialog from '@material-ui/core/Dialog';
import MUIContainer from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';

export const BaseDialog = styled(MUIDialog)`
  overflow-x: hidden;

  .MuiDialog-paperFullScreen {
    overflow-x: hidden;
  }
`;

export const Content = styled(Box)`
  ${({ theme: { breakpoints, colors } }) => `
    display: flex;
    flex-direction: column;
    height: 100%;
    padding-top: 80px;

    ${breakpoints.up('md')} {
      padding-top: 100px;
    }
  `}
`;

export const Description = styled(Typography)`
  display: inline-block;
  opacity: 0.75;
  color: #003C3B;
  font-size: 18px;
  font-weight: 400;
`;

export const Title = styled.h1`
    color: #003C3B;
    font-size: 30px;
    font-weight: 700;
    display: flex;
    opacity: 0.75;
`;

export const Header = styled(Box)`
  ${({ theme: { breakpoints, sizes, palette } }) => `
    position: fixed;
    width: 100%;
    padding: 20px 0;
    height: ${sizes.headerHeight.sm};
    flex: 0 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: ${palette.common.white};
    z-index: 999;
    ${breakpoints.up('md')} {
      padding: 25px 0;
      height: calc(${sizes.headerHeight.default} + 1px);
      margin-bottom: 34px;
    }
  `}
`;

export const Container = styled(MUIContainer)`
  height: 100%;
`;

export const HeaderContainer = styled(MUIContainer)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  
`;



export const ImageContainer = styled(Box)`
  ${({ theme: { breakpoints, colors } }) => `
      display: flex;
      align-items: center;
      padding-top: 8px;
    ${breakpoints.up('md')} {

    }
  `}
`;